/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='far fa-arrow-left'></i>", "<i class='far fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: slides.length,
      autoHeight: autoHeight
    });

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
					Grid Carousel - Create responsive array 
					========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

(function ($) {
  /*  ==========================================================================
			Device Detection - Check if is mobile or ipad
			========================================================================== */

  var isMobile = false; // initiate as false
  var isTouchDevice = !!("ontouchstart" in window);

  if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  }

  /*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

  // Lazy load images (or everything with .lazy)
  const lazyLoadInstance = new LazyLoad();

  /*  ==========================================================================
			links
			========================================================================== */

  const linksInit = function () {
    const links = document.querySelectorAll("a:not(.noanchorline):not(.line--added)");
    links.forEach(function (el) {
      if (el.closest(".noanchorline")) {
        return;
      }

      const icon = el.querySelector(".fa, .fas, .far, .fal, .fab");

      if (el.querySelector("img") < 1) {
        const linkHTML = "<span class='anchorline'>" + el.textContent + "</span>";
        el.innerHTML = linkHTML;
        el.classList.add("line--added");
        if (icon) {
          const iconHTML = icon;
          if (icon.classList.contains("fa--left")) {
            el.querySelector(".anchorline").before(icon);
          } else {
            el.querySelector(".anchorline").after(icon);
          }
        }
      }
    });
    //return true;
  }; // linksInit();
  linksInit();

  /*  ==========================================================================
		Check Scroll
		========================================================================== */

  function checkScroll() {
    if ($(window).scrollTop() > 10) {
      $(".navbar").addClass("navbar--scrolled");
    } else {
      $(".navbar").removeClass("navbar--scrolled");
    }
    var scroll = $(window).scrollTop();

    if (scroll >= 600) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  }

  $(window).scroll(function () {
    checkScroll();
  });

  checkScroll();

  /*  ==========================================================================
			sharinglinks
			========================================================================== */

  $(".sharelink--popup").click(function (e) {
    e.preventDefault();
    window.open($(this).attr("href"), "share-dialog", "width=550,height=436");
  });

  /*  ==========================================================================
			accordion text content
			========================================================================== */

  $(".accordion__question").click(function () {
    $(this).closest(".accordion__item").toggleClass("accordion__item--open");
  });

  /*  ==========================================================================
		accordion
		========================================================================== */

  $(".accordion__header").click(function () {
    $(this).closest(".accordion__content").toggleClass("accordion__content--open");
  });

  /*  ==========================================================================
			pageheader gallery
			========================================================================== */

  var $pageheader__gallery = $(".pageheader__gallery");

  if ($pageheader__gallery.length > 0) {
    gallery__init();
  }

  function gallery__init() {
    $pageheader__gallery.each(function () {
      var $this = $(this);
      var $this_slidecount = $(".pageheader__gallery__img", $this).length;
      if ($this_slidecount > 1) {
        $this.owlCarousel({
          loop: true,
          animateOut: "fadeOut",
          nav: false,
          dots: false,
          items: 1,
          startPosition: $this_slidecount,
          autoHeight: false,
          autoplay: true,
          autoplayTimeout: 7000
        });
      }
    });
  } // gallery__init()

  /*  ==========================================================================
    Scroll effects
    ========================================================================== */

  const effects = document.querySelectorAll(".fade");

  const effectsInit = function () {
    if (!effects) {
      return;
    }

    effects.forEach(function (val) {
      const waypoints = new Waypoint({
        element: val,
        handler: function (direction) {
          if (direction === "down") {
            val.classList.add("fade--in");
          } else {
            val.classList.remove("fade--in");
          }
        },
        offset: "95%"
      });
    });
  }; // effectsInit();
  effectsInit();

  /*  ==========================================================================
			pageheader video background
			========================================================================== */

  // Fade in page header video when ready
  if ($("#pageheadervideo__iframe").length) {
    var iframe = document.getElementById("pageheadervideo__iframe");
    var player = new Vimeo.Player(iframe);
    player.ready().then(function () {
      $("body").addClass("pageheader-video-playing");
    });
  }

  /*  ==========================================================================
			AJAX load more / paging
			========================================================================== */

  $(".paging__loadmore").click(function () {
    var button = $(this);
    var data = {
      action: "loadmore",
      query: php_variables.posts, // that's how we get params from wp_localize_script() function
      page: php_variables.current_page
    };
    var button_text; // create variable to store button text

    // This AJAX triggers a PHP hook within function-hooks.php called ajax_loadmore_handler
    $.ajax({
      url: php_variables.ajax_url, // AJAX handler
      data: data,
      type: "POST",
      beforeSend: function (xhr) {
        button_text = button.html(); // store current button text
        button.text("Loading..."); // change the button text, to let the user know we are loading more posts
      },
      success: function (data) {
        if (data) {
          button.html(button_text); // set back to previous button text
          $(".loadmore-container").append(data); // insert new posts to the loadmore-container, this should be the row that includes the posts
          php_variables.current_page++;
          // if last page, remove the button..
          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            button.remove();
          }
          // Re-init links to make sure anchorlines on newly loaded content still work
          links__init();
        } else {
          button.remove(); // if no data, remove the button as well
        }
      }
    });
  });

  const loadmoreLoadPosts = function () {
    if (!loadmoreBtn || isLoading) {
      return;
    }

    const data = {
      action: "loadmore",
      query: php_variables.posts,
      page: php_variables.current_page
    };

    let buttonText;

    $.ajax({
      url: php_variables.ajax_url,
      data: data,
      type: "POST",
      beforeSend: function () {
        isLoading = true;
        buttonText = loadmoreBtn.textContent;
        loadmoreBtn.textContent = "Loading...";
      },
      success: function (data) {
        if (data) {
          loadmoreBtn.textContent = buttonText;
          loadmoreContainer.insertAdjacentHTML("beforeend", data);
          php_variables.current_page++;

          if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
            loadmoreBtn.remove(); // no more posts
          } else {
            initScrollLoadmore(); // re-init scroll after appending
          }

          // Re-inits
          linksInit();
          lazyLoadInstance.update();
          effectsInit();
        } else {
          loadmoreBtn.remove();
        }
      },
      complete: function () {
        isLoading = false;
      }
    });
  }; // loadmoreLoadPosts()

  const loadmoreBtn = document.querySelector(".paging__loadmore");
  const loadmoreContainer = document.querySelector(".loadmore-container");
  let isLoading = false;

  const initScrollLoadmore = function () {
    if (!loadmoreBtn) {
      return;
    }

    // destroy old waypoints to avoid duplicates
    Waypoint.destroyAll();

    new Waypoint({
      element: loadmoreBtn,
      handler: function (direction) {
        if (direction === "down") {
          loadmoreLoadPosts();
        }
      },
      offset: "99%"
    });
  }; // initScrollLoadmore()

  const loadmoreInit = function () {
    if (!loadmoreBtn) {
      return;
    }

    // click fallback
    loadmoreBtn.addEventListener("click", loadmoreLoadPosts);

    // scroll trigger
    initScrollLoadmore();
  }; // loadmoreInit()
  loadmoreInit();

  /*  ==========================================================================
			Search open
			========================================================================== */

  // Search open & close
  if ($(".navbar__search").length) {
    $(".search-toggle").click(function () {
      if ($(this).closest(".navbar").find(".navbar__search").hasClass("navbar__search--open")) {
        $(this).closest(".navbar").find(".navbar__search").removeClass("navbar__search--open");
      } else {
        $(this).closest(".navbar").find(".navbar__search").addClass("navbar__search--open");
        $(this).closest(".navbar").find(".navbar__search .searchform__input input").focus();
      }
    });
  }

  // Hide search when clicking anywhere else on the page
  $(document).mouseup(function (e) {
    var search_container = $(".navbar__search");
    var search_toggle = $(".search-toggle");
    if (
      !search_container.is(e.target) &&
      search_container.has(e.target).length === 0 &&
      !search_toggle.is(e.target) &&
      search_toggle.has(e.target).length === 0
    ) {
      $(search_container).removeClass("navbar__search--open");
    }
  });

  /*  ==========================================================================
			NAVIGATION - navbar-mobile
			========================================================================== */

  var $mobnav = $(".navbar-mobile");
  var $navbarbd = $(".container");
  var $mobnavtoggle = $(".navbar-mobile-toggle");
  var mobnavopenclass = "navbar-mobileopen";

  mobnav__init();

  function mobnav__init() {
    // Open mobnav on click the toggle
    $mobnavtoggle.on("click touchend", function (e) {
      e.preventDefault();
      if (!$("body").hasClass(mobnavopenclass)) {
        // IT'S NOT OPEN...
        $mobnav.addClass("navbar-mobile--open");
        $("body").addClass(mobnavopenclass);
      } else {
        // IT'S OPEN...
        $("body").removeClass(mobnavopenclass);
        $mobnav.removeClass("navbar-mobile--open");
      }
    });
  } // mobnav__init()

  /*  ==========================================================================
			NAVIGATION - mobnav dropdowns
			========================================================================== */

  $(".navbar-mobile .navbar-mobile__section.has-dropdown .navbar-mobile__link i").click(function (e) {
    e.preventDefault();
    $(".navbar-mobile__section").removeClass("navbar-mobile__section--open");
    $(this).closest(".navbar-mobile__section").toggleClass("navbar-mobile__section--open");
  });

  /*  ==========================================================================
			NAVIGATION - sitenav dropdowns
			========================================================================== */

  var $sitenav = $(".navbar-nav");
  var $sitenavitems = $("li[data-sitenavsection]", $sitenav).not(".hover-avoid");
  var $sitenavdropdown = $(".navbar-nav__dropdown");
  var $body = $("body");

  var overclass = "navbar_item--over";
  var navopenbodyclass = "navbar-navopen";
  var activesectionclass = "navbar-navsection--active";

  var navopen = false;
  var $currentli = false;
  var dropdownclosetimer = false;

  // Check if isMobile, and only init if desktop or Ipad
  if (!isMobile) {
    navbar__init();
  }

  function navbar__init() {
    // Check if is touchscreen and setup dropdown to show on tap as well as hover
    if (isTouchDevice) {
      // IF TOUCHSCREEN (e.g. Ipad users)...
      // Setup dropdown to show on tap
      $sitenavitems.on("tap click hover", function (e) {
        $this = $(this);
        e.preventDefault();
        if ($this.hasClass("over")) {
          navopen = false;
          sitenav__close();
        } else {
          sitenavsection__open($this);
        }
      });
    } else {
      // IF DESKTOP...
      $sitenavitems.mouseover(sitenavitem__over).mouseout(sitenav__out);
      $sitenavdropdown.mouseover(sitenavsection__over).mouseout(sitenav__out);
    }
  } // navbar__init()

  function sitenavitem__over() {
    // On hover of sitenav item
    var $this = $(this);
    sitenavsection__open($this);
  } // sitenavitem__over()

  function sitenavsection__open($target_li) {
    $this = $target_li;
    var $targetsection = $sitenavdropdown.find(".navbar-navsection--" + $this.attr("data-sitenavsection"));
    var dropdown_height = $sitenavdropdown.find(".navbar-navsection--" + $this.attr("data-sitenavsection")).height();

    // Make dropdown show and set classes to say it's open
    $sitenavdropdown.css("height", dropdown_height);
    navopen = true;
    if (dropdownclosetimer) {
      // Clear timeout to stop dropdown closing
      window.clearTimeout(dropdownclosetimer);
    }
    $("." + overclass, $sitenav).removeClass(overclass);
    $this.addClass(overclass);
    $body.addClass(navopenbodyclass);
    $currentli = $this;
    $("." + activesectionclass).removeClass(activesectionclass);
    $targetsection.addClass(activesectionclass);
  } //sitenavsection__open();

  function sitenavsection__over() {
    // On hover of sitenavsection, keep the dropdown open
    navopen = true;
    if (dropdownclosetimer) {
      // Clear timeout to close the dropdown
      window.clearTimeout(dropdownclosetimer);
    }
    $body.addClass(navopenbodyclass);
  } // sitenavitem__over()

  function sitenav__out() {
    // On leave sitenav hover
    navopen = false;
    // Start timeout to close sitenav dropdown
    dropdownclosetimer = window.setTimeout(sitenav__close, 250);
  } // sitenavitem__over()

  function sitenav__close() {
    // when time out ends and nav open is still false, close the sitenav
    if (!navopen) {
      // Set height to 0 and remove classes
      $("." + activesectionclass).removeClass(activesectionclass);
      $body.removeClass(navopenbodyclass);
      if ($currentli) {
        $currentli.removeClass(overclass);
      }
      $sitenavdropdown.css("height", 0);
    }
  } // sitenav__close

  $(".project__link").hover(function () {
    $(this).find(".btn").hover();
  });

  /*  ==========================================================================
		ACF Map setup
			========================================================================== */
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find(".marker");

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data("zoom") || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function () {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data("lat");
    var lng = $marker.data("lng");
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: php_variables.template_url + "/img/map-marker.png"
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html()
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, "click", function () {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function (marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng()
      });
    });

    // Case: Single marker.
    if (map.markers.length === 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function () {
    if ($(".acf-map").length >= 1) {
      $(".acf-map").each(function () {
        var map = initMap($(this));
      });
    }
  });

  /*  ==========================================================================
	 Filters
	 ========================================================================== */

  $(".filter__search__toggle").click(function () {
    $(".filter__search__container").toggleClass("filter__search__container--open");
  });

  mobile__filter();

  $(window).on("resize", function () {
    mobile__filter();
  });

  function mobile__filter() {
    if ($(window).width() < gridSizes.md) {
      $(".filter__title").click(function () {
        $(".filter__options").addClass("filter__options--open");
        $(this).addClass("filter__title--clicked");
      });

      $(".filter__title--clicked").click(function () {
        $(".filter__options").removeClass("filter__options--open");
        $(this).removeClass("filter__title--clicked");
      });

      $(".filterbar__filterdropdown span").click(function () {
        $(".filterbar__filterdropdown__submenu").toggleClass("filterbar__filterdropdown__submenu--active");
        $(this).toggleClass("filter--clicked");
      });

      $(".span.filter--clicked").click(function () {
        $(".filterbar__filterdropdown__submenu").removeClass("filterbar__filterdropdown__submenu--active");
        $(this).removeClass("filter--clicked");
      });
    }
  }

  var $filterbars = $(".filterbar");

  if ($filterbars.length) {
    filterbar__init();
  }

  function filterbar__init() {
    filters__init();
  }

  function filters__init() {
    // On filter select change, submit form
    $(".filterbar__filterdropdown__select").click(function () {
      var data_value = $(this).attr("data-value");

      $(".filterbar__filterdropdown__select").val(data_value).change();

      $(".filterbar__filterdropdown__select option[id='" + data_value + "']").attr("selected", "selected");
      var form = $(this).closest(".filterbar__form");
      var other_selects = $(form).find(".filterbar__filterdropdown__select").not(this);
      $(other_selects).each(function () {
        $(this).val("");
      });
      $(".filterbar__form").submit();
    });

    $(".filterbar__form .filterbar__filterdropdown__select").change(function () {
      var selected = $(this);

      // show loading bar
      $(this).closest(".filterbar").find(".filterbar__loading").addClass("filterbar__loading--show");
      // submit form
      var form = $(this).closest(".filterbar__form");
      var other_selects = $(form).find(".filterbar__filterdropdown__select").not(this);
      $(other_selects).each(function () {
        $(this).val("");
      });
      $(this).closest(".filterbar__form").submit();
    });
  }

  var form_count = 1;
  jQuery(document).on("nfFormReady", function (e, layoutView) {
    var $branding_brainstorm = $(".branding-brainstorm");

    if ($branding_brainstorm.length && form_count === 1) {
      form_count++;
      setTimeout(function () {
        $(".ninja-preferred-styles .listcheckbox-wrap :input").each(function () {
          let value = $(this).val();
          $(this).parent().addClass("select--imgwrapper");
          $(this)
            .parent()
            .append("<div class='select--img__" + value + " select--img'></div>");
        });
      }, 5000);

      setTimeout(function () {
        $(".select--img").each(function () {
          $(this).addClass("loaded");
        });
      }, 6000);
    }
  });

  var $moduleecologi = $(".componentecologi");

  if ($moduleecologi.length) {
    moduleecologi__init();
  }

  function moduleecologi__init() {
    const settings = {
      async: true,
      crossDomain: true,
      url: "https://public.ecologi.com/users/designjdltd/impact",
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    };

    $.ajax(settings).done(function (response) {
      console.log(response);
      $(".trees__planted").attr("data-count", response.trees);
      $(".carbon__offset").attr("data-count", response.carbonOffset);

      $(".counter").each(function () {
        var $this = $(this),
          countTo = $this.attr("data-count");

        $({ countNum: $this.text() }).animate(
          {
            countNum: countTo
          },
          {
            duration: 3000,
            easing: "linear",
            step: function () {
              $this.text(Math.round(this.countNum));
            },
            complete: function () {
              $this.text(this.countNum);
            }
          }
        );
      });
    });
  }

  /*  ==========================================================================
    Marquee - Infinite Scroll
    ========================================================================== */

  const default_animation_speed = 1.5;

  const elClass = "marquee";
  const innerClass = "marquee__wrap";

  const marqueeElements = document.querySelectorAll(".marquee");

  const marquee__reset = function (el) {
    const wrapElements = el.querySelectorAll("." + innerClass);

    const viewportWidth = window.innerWidth;
    const minWidth = (viewportWidth * 1) / 2;

    // If the width of the wrap is less than the minimum width we need to duplicate existing tiles
    if (wrapElements[0].offsetWidth < minWidth) {
      // Getting the orginal items
      const originalNumItems = el.dataset.count ? el.dataset.count : 1;

      let orginalTiles = "";

      const tiles = wrapElements[0].querySelectorAll(".marquee__tile");

      for (let index = 0; index < originalNumItems; index++) {
        orginalTiles += '<div class="marquee__tile">' + tiles[index].innerHTML + "</div>";
      }

      //Calculating how many times do we need to repeat the original tiles based of the width of the tile
      const numTiles = tiles.length;
      const textWidth = tiles[0].offsetWidth * numTiles;
      const timesToRepeat = Math.ceil((minWidth - wrapElements[0].offsetWidth) / textWidth);

      //Adding the extra tiles to the three wraps
      for (let index = 0; index < timesToRepeat; index++) {
        wrapElements[0].innerHTML += orginalTiles;
        wrapElements[1].innerHTML += orginalTiles;
        wrapElements[2].innerHTML += orginalTiles;
      }
    }
  };

  const marquee__resize = function (el) {
    // Check if the marquee is large enought for the space
    marquee__reset(el);

    // Check if element has custom speed or default
    let animation_speed = default_animation_speed;
    if (el.dataset.speed) {
      animation_speed = el.dataset.speed;
    } else {
      animation_speed = default_animation_speed;
    }

    const wrapElements = el.querySelectorAll("." + innerClass);

    // Calculate the animation time and delay for each wrap
    let linelength = wrapElements[0].offsetWidth;
    let distance = linelength;
    let speed = animation_speed * 0.01;
    let duration = distance / speed;

    let delay = 0 - duration / 3;

    wrapElements.forEach(function (wrap, index) {
      let count = index + 1;
      wrap.style.animationDuration = duration + "ms";
      wrap.style.animationDelay = delay * count + "ms";
    });
  };

  const marquee__init = function () {
    if (!marqueeElements) {
      return;
    }

    window.addEventListener("resize", function () {
      marqueeElements.forEach(function (el) {
        // Setup animation times
        marquee__resize(el);
      });
    });

    // Repeating Logos and Text to make sure it fills the width of the view port
    const viewportWidth = window.innerWidth;
    const minWidth = (viewportWidth * 1) / 2;

    marqueeElements.forEach(function (el) {
      // Wrapping the tiles
      el.innerHTML = "<div class='" + innerClass + "'>" + el.innerHTML + "</div>";

      // Duplicating the wrap element
      const repeatingTextClone = el.querySelector(".marquee__wrap").cloneNode(true),
        repeatingTextClone2 = el.querySelector(".marquee__wrap").cloneNode(true);

      repeatingTextClone.ariaHidden = "true";
      repeatingTextClone2.ariaHidden = "true";

      el.appendChild(repeatingTextClone);
      el.appendChild(repeatingTextClone2);

      // Force all lazy images within carousels to load immediately, otherwise they wont load
      const marquee_lazyimgs = document.querySelectorAll(".marquee .lazy");
      marquee_lazyimgs.forEach(img => {
        LazyLoad.load(img);
      });

      // Setup animation times
      marquee__resize(el);

      // Once everything is set up, add "loaded" class
      el.classList.add(elClass + "--loaded");
    });
  };

  // Defer loading this code until after page load
  window.addEventListener("load", marquee__init);
})(jQuery); // Domready
